var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 20.95,
    viewBox: "0 0 24 20.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "video-chat",
    transform: "translate(-3 -4.525)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87861",
    "data-name": "Path 87861",
    d: "M24.62,4.525H5.38A2.388,2.388,0,0,0,3,6.915V18.9a2.386,2.386,0,0,0,2.38,2.38H6.47v3.2a.982.982,0,0,0,.57.9,1,1,0,0,0,1.06-.12l4.95-3.98H24.62A2.386,2.386,0,0,0,27,18.9V6.915a2.388,2.388,0,0,0-2.38-2.39Zm-6.26,9.34-3.65,2.51a1.488,1.488,0,0,1-1.58.1,1.532,1.532,0,0,1-.82-1.36v-5.02a1.528,1.528,0,0,1,2.4-1.26l3.65,2.51a1.533,1.533,0,0,1,0,2.52Z",
    fill: "#444"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoChat);
export default __webpack_public_path__ + "static/media/videoChat.eaafae70f13550ce339b7b1e945a6f36.svg";
export { ForwardRef as ReactComponent };